import DOMPurify from 'dompurify';
import { stripHtmlTag } from 'utils/stripHtmlTag';
import { TradeDetailLogisticsBlock } from 'views/Conversation/Sider/useTradeDetailBusiness';

export interface UILogistics {
  externalTradeId?: string;
  trackingNumber: string;
  leChatStatus: Conversation.Trade.LeChatLogisticsStatus;
  trackingInfo: Conversation.Trade.BaseTrackingInfo[];
  trackingStatus?: Conversation.Trade.LogisticsStatus;
  packageNumber?: string;
  firstMileTrackingNumber?: string;
  lastMileTrackingNumber?: string;
  plpNumber?: string;
  shippingCarrier?: string;
  warehouseCode?: string;
  gxbLogisticsNo?: string;
  logisticsNo?: string;
  trackingClass?: 'BOOKING';
}

export const formatLogisticsInfo = (
  blockPayload: TradeDetailLogisticsBlock['payload'],
): UILogistics[] => {
  if (blockPayload.kind === 'common') {
    return blockPayload.logisticsList.map((logistics) => ({
      externalTradeId: logistics.externalTradeId,
      trackingNumber: logistics.trackingNumber,
      leChatStatus: logistics.leChatStatus,
      trackingStatus: logistics.trackingStatus,
      packageNumber: logistics.packageNumber,
      trackingInfo: logistics.trackingInfo,
      firstMileTrackingNumber: logistics.firstMileTrackingNumber,
      lastMileTrackingNumber: logistics.lastMileTrackingNumber,
      plpNumber: logistics.plpNumber,
      shippingCarrier: logistics.shippingCarrier,
      trackingClass: logistics.trackingClass,
    }));
  }
  if (blockPayload.kind === 'commonThird' || blockPayload.kind === 'hisense') {
    return blockPayload.logisticsList.map((logistics) => ({
      externalTradeId: logistics.externalTradeId,
      trackingNumber: logistics.trackingNumber,
      leChatStatus: logistics.leChatStatus,
      trackingInfo: logistics.trackingInfo,
      gxbLogisticsNo: logistics.gxbLogisticsNo,
      logisticsNo: logistics.logisticsNo,
    }));
  }
  if (blockPayload.kind === 'lazada') {
    return blockPayload.logisticsList.map((logistics) => ({
      trackingNumber: logistics.trackingNumber,
      leChatStatus: logistics.leChatStatus,
      trackingInfo: logistics.trackingInfo,
      shippingCarrier: logistics.shippingCarrier,
      warehouseCode: logistics.warehouseCode,
    }));
  }
  if (blockPayload.kind === 'mercado') {
    const logistics = blockPayload.logistics;
    return [
      {
        shippingCarrier: logistics.shippingCarrier,
        leChatStatus: logistics.leChatStatus,
        trackingNumber: logistics.trackingNumber,
        packageNumber: logistics.packageNumber,
        trackingInfo: logistics.trackingInfo.map((info) => ({
          updateTime: info.updateTime,
          description: info.description,
          descriptionTranslation: {} as Conversation.Trade.Translation,
        })),
      },
    ];
  }

  return [];
};

export const stringifyTrackingInfo = (trackingInfo: Conversation.Trade.BaseTrackingInfo[]) => {
  return trackingInfo.map((info) => {
    const { description } = info;
    try {
      const text = DOMPurify.sanitize(decodeURIComponent(description), {
        RETURN_DOM: true,
      }).innerText;
      return stripHtmlTag(text);
    } catch (error) {
      //
      return '';
    }
  });
};
